import item from '@/api/promotion/buy-item-free-item'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
    ...baseState
}

export const getters = {

}

export const mutations = {
    ...baseMutations
}

export const actions = {
  store(context, data) {
    return item.store(data)
  },
  update(context, { id, data }) {
    return item.update(id, data)
  },
  find(context, id) {
    return item.find(id)
  }
}